const Exam = {
    "exam": "Exam",
    "institute": "Institute",
    "branch": "Branch Office",
    "title": "Title",
    "course": "Course",
    "subject": "Subject",
    "topic": "Test Paper",
    "topic_questions": "Test Paper Questions",
    "duration": "Duration (min)",
    "total_marks": "Total Marks",
    "pass_percentage": "Pass Percentage",
    "date": "Exam Date",
    "start_time": "Start Time",
    "end_time": "End Time",
    "seats": "Student Seats",
    "terms_pdf": "Terms & Conditions PDF",
    "status": "Status",
    "search": "Search",
    "error_institute": "Select Institute",
    "error_branch": "Select Branch Office",
    "error_title": "Enter Title",
    "error_course": "Select Course",
    "error_topic": "Select Test Paper",
    "error_subject": "Select Subject",
    "error_duration": "Enter Duration",
    "error_total_marks": "Enter Total Marks",
    "error_pass_percentage": "Enter Pass Percentage",
    "error_date": "Enter Exam Date",
    "error_start_time": "Enter Start Time",
    "error_end_time": "Enter End Time",
    "error_seats": "Enter Student Seats",
    "error_pdf": "Upload Terms & Conditions PDF",
    "error_status": "Select Status",
    "table_topic": "TEST PAPER",
    "table_title": "TITLE",
    "table_duration": "DURATION",
    "table_date": "DATE",
    "table_start_time": "START TIME",
    "table_status": "STATUS",
}

export default Exam;
